<template>
  <div class="transition">
    <v-card class="p-5" shaped elevation="10">
      <h2 class="text-lg md:text-base text-neutral-600">{{ header.title }}</h2>
      <div class="flex justify-center w-full" v-if="loading">
        <Lynx-Spinner size="12" />
      </div>
      <div v-else class="w-full">
        <div class="w-full flex justify-between items-center grid-cols-3">
          <label class="flex flex-col w-2/5 pb-3 pr-5">
            <Lynx-Label label="Data Historico" />
            <b-datepicker
              placeholder="Selecione uma data"
              icon="calendar-today"
              :month-names="monthNames"
              @input="fetchResults"
              v-model="entreDatas"
              range
            />
          </label>
          <label class="flex flex-col w-1/5 pt-4 pr-5 items-end">
            <v-row>
              <p class="pt-4 pr-1" style="font-size: 20px">%</p>
              <b-switch v-model="isValor" outlined> Qtd </b-switch>
            </v-row>
          </label>
        </div>

        <div class="pt-2 w-full">
          <EmpresaStatusChart
            :isValor="isValor"
            :values="dataSet"
            :label="label"
          />
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import EmpresaStatusChart from "@/views/charts/empresas/EmpresaStatusChart";
import { companiesOpeningStatsRequest } from "@/services/requests/charts";

import NotFoundData from "@/components/layouts/NotFoundData";
import moment from "moment";
import { monthNames, dayNames } from "@/utils/utils";


export default {
  name: "EmpresaStatus",
  components: { EmpresaStatusChart },
  data() {
    return {
      header: {
        title: "Status Pos cadastro",
        icon: "Document",
      },
      loading: true,
      dataSet: [],
      label: [],
      entreDatas:[],
      form: { 
        data:null,
       carteira_id: null },
      monthNames,
      dayNames,
      moment,
      isValor:true
    };
  },
  computed: {
    onboarding_search() {
      return this.$store.state.configEmpresa.onboarding_search;
    },
  },
  watch: {
    onboarding_search() {
      this.fetchResults();
    },
  },
  methods: {
    fetchResults() {
      if(this.entreDatas.length){
        this.form.data = this.entreDatas
      }
      this.form.carteira_id = this.onboarding_search;
      this.loading = true;
      companiesOpeningStatsRequest(this.form)
        .then((res) => {
          this.dataSet = res.data.datasets;
          this.label = res.data.label;
        })
        .finally(() => (this.loading = false));
    },
  },
  beforeMount() {
    this.fetchResults();
  },
};
</script>
